import Service from '@ember/service';
import { loadScript } from 'sh-www/utils/script-loader';

export const isCalendlyEvent = (e) => (
  e.origin === 'https://calendly.com' &&
  e.data.event?.indexOf('calendly.') === 0
);

class CalendlyService extends Service {
  #promise = null;

  load() {
    return (this.#promise ??= loadScript('https://assets.calendly.com/assets/external/widget.js'));
  }
}

export default CalendlyService;
